import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Masonry from 'masonry-layout';
import Twig from 'twig';

let Reports = {
    ajaxAdd: function(_id, type){

        let overwrite = false,
            reportsContainer = $('[data-reports]'),
            listReports = reportsContainer.find('[data-reports-js-masonry]'),
            btnShowMore = reportsContainer.find('[data-show-more-reports]'),
            currPage = btnShowMore.data('show-more-reports');

        if(type == 'select') {
            overwrite = true;
        }

        if(overwrite){
            btnShowMore.data('show-more-reports', 1);
            btnShowMore.removeAttr('style');
            currPage = 0;
        }else {
            btnShowMore.data('show-more-reports', currPage + 1);
        }

        $.ajax({
            url: '/'+window.langId+'/ajax/reports.php',
            data: {
                selected: _id,
                PAGEN_1: currPage + 1
            },
            dataType: 'json',
            beforeSend: function(){},
            success: function(_data){

                if(_data.items.length > 0){

                    if(overwrite){
                        listReports.empty().removeAttr('style');
                    }
/*
                    // пагинация
                    if (_data.nav_info.page_count <= 1) {
                      $('.reports__pagination').hide();
                    } else {
                      var paginationTemplate = Twig.twig({
                          data: '<div class="pagination" data-current-page="{{data.currentPage}}">\n' +
                          '    {% if data.currentPage == 1 %}\n' +
                          '        <div class="pagination__prev disabled">\n' +
                          '            <span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow-right"></use></svg></span>\n' +
                          '        </div>\n' +
                          '    {% else %}\n' +
                          '        <a href="{{ data.listUrl }}?PAGEN_{{ data.navNum }}={{  data.currentPage - 1 }}" class="pagination__prev">\n' +
                          '            <span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow-right"></use></svg></span>\n' +
                          '        </a>\n' +
                          '    {% endif %}\n' +
                          '    <div class="pagination__content">\n' +
                          '        <span class="pagination__current-page">{{data.currentPage}}</span>\n' +
                          '        <span class="">{% if data.strOf is empty %} из {% else %} {{ data.strOf }} {% endif %} {{data.countAllPage}}</span>\n' +
                          '    </div>\n' +
                          '    {% if data.currentPage == data.countAllPage or data.countAllPage == 0 %}\n' +
                          '        <div class="pagination__next disabled">\n' +
                          '            <span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow-right"></use></svg></span>\n' +
                          '        </div>\n' +
                          '    {% else %}\n' +
                          '        <a href="{{ data.listUrl }}?PAGEN_{{ data.navNum }}={{ data.currentPage + 1 }}" class="pagination__next">\n' +
                          '            <span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow-right"></use></svg></span>\n' +
                          '        </a>\n' +
                          '    {% endif %}\n' +
                          '</div>'
                        }
                      );
                      var $pagination = $('.reports__pagination');
                      $pagination.show().html(
                        paginationTemplate.render({
                          data: {currentPage: _data.nav_info.cur_page, countAllPage: _data.nav_info.page_count, navNum: $pagination.attr('data-nav-num')}
                        })
                      );
                    }
*/
                    if(currPage + 1 >= _data.nav_info.page_count) {
                        btnShowMore.hide();
                    } else {
                        btnShowMore.show();
                    }

                    var template = Twig.twig({
                        data:   '<div class="item-reports item-reports_{{ data.size }}" data-reports-js-masonry-item="true">'+
                                    '<div class="item-reports__content">'+
                                        '<a href="{{ data.link }}" class="item-reports__img" style="background-image: url(\'{{ data.img }}\')"></a>'+
                                        '<a href="{{ data.link }}" class="item-reports__title">'+
                                            '{{ data.title|raw }}'+
                                        '</a>'+
                                    '</div>'+
                                '</div>'
                    });

                    _data.items.forEach(function(item, i){
                        var $el = $(template.render({
                            data: {
                                link: item.DETAIL_PAGE_URL,
                                img: item.PREVIEW_PICTURE,
                                title: item.NAME,
                                size: item.size
                            }
                        }));

                        listReports.append($el).masonry('appended', $el);
                    });

                    listReports.masonry('layout');
                } else {
                    listReports.empty().removeAttr('style');
                    btnShowMore.hide();
                }
            }
        });
    },
    initSelect: function(elem){
        elem.selectize({
            onChange: function(value){

                var elem = this.$input[0],
                    container = $(elem).closest('[data-select-reports-wrap]');

                // fix бага selectize с выбранным элементом
                container.find('.option').removeClass('selected');
                container.find('[data-value="'+value+'"].option').addClass('selected');

                Reports.ajaxAdd(value, 'select');

                $.cookie('reports_select', value);
            },
            onInitialize: function (value) {
                this.$dropdown.css('visibility', 'hidden').css('opacity', '0');
            },
            onDropdownOpen: function (dropdown) {
                var self = this;

                $(dropdown)
                  .css('width', this.$control[0].offsetWidth + 'px')
                  .css('top', this.$control[0].offsetHeight + 'px')
                  .css('visibility', 'visible')
                  .css('opacity', '1');

                $(dropdown).addClass('has-scrollbar');
                $(dropdown).find('.selectize-dropdown-content').addClass('nano-content');

                setTimeout(function(){
                    $(dropdown).nanoScroller({scroll: 'top'});
                    self.$dropdown[0].nanoscroller.reset();
                }, 100);
            },
            onDropdownClose: function (dropdown) {
                $(dropdown).css('visibility', 'hidden').css('opacity', '0');

                setTimeout(function () {
                    $(dropdown).prev().find('input').blur();
                }, 250);
            }
        });
    }
}

$(document).ready(function($) {

    jQueryBridget('masonry', Masonry, $);

    let reportsList = $('[data-reports-js-masonry]');
    if(reportsList.length){

        reportsList.masonry({
            itemSelector: '[data-reports-js-masonry-item]',
            columnWidth: '[data-reports-js-masonry-item]'
        });
    }

    let selectReports = $('[data-select-reports]');
    if(selectReports.length) {
        Reports.initSelect(selectReports);
    }

    let showMoreReports = $('[data-show-more-reports]');
    if(showMoreReports.length){

        showMoreReports.on('click', function(e){
            e.preventDefault();

            let _this = $(this),
                container = _this.closest('[data-reports]'),
                selectize = container.find('[data-select-reports]');

                Reports.ajaxAdd(selectize.val(), 'btn');
        });
    }
        
});


// WEBPACK FOOTER //
// ./components/reports.js